module.exports = __webpack_public_path__ + "static/media/trees_in_the_meadow.649335af.jpg";